import { render, staticRenderFns } from "./TalentPsychometric.vue?vue&type=template&id=0fd73db0&scoped=true"
import script from "./TalentPsychometric.vue?vue&type=script&lang=js"
export * from "./TalentPsychometric.vue?vue&type=script&lang=js"
import style0 from "./TalentPsychometric.vue?vue&type=style&index=0&id=0fd73db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd73db0",
  null
  
)

export default component.exports